import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientService } from './api-client.service';
import { MeRoleApi } from '../models/api/departments';

@Injectable({
  providedIn: 'root',
})
export class AppRoleApiService {
  private readonly apiClient = inject(ApiClientService);

  getCurrentRole(): Observable<MeRoleApi> {
    return this.apiClient.get<MeRoleApi>('/me/role');
  }
}
